import { render, staticRenderFns } from "./BoxesByPartnerGroups.vue?vue&type=template&id=158617c4&scoped=true&"
import script from "./BoxesByPartnerGroups.vue?vue&type=script&lang=js&"
export * from "./BoxesByPartnerGroups.vue?vue&type=script&lang=js&"
import style0 from "./BoxesByPartnerGroups.vue?vue&type=style&index=0&id=158617c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158617c4",
  null
  
)

export default component.exports